<ng-select
[items]="options"
[loading]="isLoading"
[virtualScroll]="true"
[(ngModel)]="selected"
[typeahead]="typeahead$" 
(change)="onSelect($event)"
[clearable] = "true"
[placeholder] ="config.placeholder? config.placeholder : ''"
(scrollToEnd)="onScrollToEnd()"
[disabled]="isLoading">

</ng-select> 

